import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import "../../../components/customer-information/customer-information.css";
import { useDispatch } from "react-redux";
import AddButton from "../../buttons/button";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import InputField from "../../forms/input-field";
import SelectField from "../../forms/select-field";
import {
  roundingMethodoptions,
  roundingRuleoptions,
} from "../../helper-components/data";
import { priceListAction } from "../../../redux/actions/general-action";
import { priceListEditAction } from "../../../redux/actions/discount-action";
import PriceListItemTable from "./price-list-items-table";
import SelectionCriteriaPopover from "./price-list-popover";
import { useHotkeys } from "react-hotkeys-hook";
import CheckBox from "../../forms/check-box-field";

const CreateEditViewPriceList = ({
  paginationProps,
  priceListData,
  setFilterData,
  filterData,
  setReload,
  reload,
}) => {
  const [selectionCriteria, setSelectionCriteria] = useState(false);
  const dispatch = useDispatch();
  const [priceList, setPriceList] = useState([]);
  useEffect(() => {
    dispatch(priceListAction(onpriceSuccess, onpriceError));
  }, []);
  const onpriceSuccess = (data) => {
    setPriceList(
      data?.data?.map((item) => {
        return { label: item?.price_list_name, value: item?.price_list_id };
      })
    );
  };
  const onpriceError = (data) => {
    // errorToast(data?.message);
  };

  const initialValues = {
    price_list_id: priceListData?.pricelist?.price_list_id,
    price_list_name: priceListData?.pricelist?.price_list_name ?? "",
    default_base_price_list_id:
      priceListData?.pricelist?.default_base_price_list_id ?? "",
    default_factor: priceListData?.pricelist?.default_factor ?? "",
    margin_factor: priceListData?.pricelist?.margin_factor ?? "",
    rounding_method: priceListData?.pricelist?.rounding_method ?? "",
    rounding_rule: priceListData?.pricelist?.rounding_rule ?? "",
    default_price_list: priceListData?.pricelist?.default_price_list ?? false,
    is_margin_percentage:
      priceListData?.pricelist?.is_margin_percentage ?? false,
  };

  const validationSchema = Yup.object().shape({
    price_list_name: Yup.string().required("Price list name is required"),
    default_base_price_list_id: Yup.string().required(
      "Default base price list ID is required"
    ),
    default_factor: Yup.number()
      .required("Discount % is required")
      .max(100, "Discount % cannot exceed 100"),
    margin_factor: Yup.number()
      .required("Margin % is required")
      .max(100, "Margin % cannot exceed 100"),
    rounding_method: Yup.string(),
    rounding_rule: Yup.string(),
  });

  const onSubmit = (values) => {
    const data = {
      default_base_price_list: priceList?.find(
        (item) => item?.value === values?.default_base_price_list_id
      )?.label,
      ...values,
    };
    dispatch(priceListEditAction(data, onSuccess, onError));
  };

  const onSuccess = (data) => {
    setReload(!reload);
    successToast(data?.message);
  };
  const onError = (data) => {
    errorToast(data?.message);
  };

  useHotkeys("escape", () => {
    setSelectionCriteria(false);
  });

  function toggleSwitch() {
    const toggleButton = document.getElementById("necessary");
    const isChecked = toggleButton.getAttribute("data-state") === "checked";

    // Toggle the state
    if (isChecked) {
      toggleButton.setAttribute("data-state", "unchecked");
      toggleButton.setAttribute("aria-checked", "false");
    } else {
      toggleButton.setAttribute("data-state", "checked");
      toggleButton.setAttribute("aria-checked", "true");
    }
  }

  // Attach the function to the button's click event
  document.getElementById("necessary")?.addEventListener("click", toggleSwitch);
  return (
    <>
      {selectionCriteria === true && (
        <SelectionCriteriaPopover
          setFilterData={setFilterData}
          filterData={filterData}
          setSelectionCriteria={setSelectionCriteria}
        />
      )}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, setFieldValue, values }) => {
          return (
            <Form className="h-full pt-5">
              <div className="flex flex-col justify-between h-full ">
                <div>
                  <div className="flex flex-wrap">
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5 ">
                      <InputField
                        type="text"
                        name="price_list_name"
                        placeholder="Enter item name"
                        label="Name"
                        isRequired={true}
                        labelWidth="8rem"
                      />

                      <SelectField
                        placeholder={"Select rounding method"}
                        options={roundingMethodoptions}
                        label={"Rounding Method"}
                        id={"rounding_method"}
                        name="rounding_method"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        labelWidth="8rem"
                      />

                      {/* </div> */}
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5 ">
                      <SelectField
                        placeholder={"Select base price"}
                        options={priceList}
                        label={"Base Price List"}
                        id={"default_base_price_list_id"}
                        name="default_base_price_list_id"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        isRequired={true}
                        labelWidth="8rem"
                      />

                      <SelectField
                        placeholder={"Select rounding rule"}
                        options={roundingRuleoptions}
                        label={"Rounding rule"}
                        id={"rounding_rule"}
                        name="rounding_rule"
                        isSearchable={true}
                        errMsgContainerClass="ps-2"
                        labelWidth="8rem"
                      />
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5">
                      <InputField
                        isDisabled={
                          values?.is_margin_percentage ||
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                        }
                        onKeyDown={(event) => {
                          if (event.key === "-" || event.key === "e") {
                            event.preventDefault();
                          }
                        }}
                        type="number"
                        name="default_factor"
                        placeholder="Enter Discount %"
                        label="Discount %"
                        isRequired={true}
                        labelWidth="8rem"
                      />
                      <InputField
                        isDisabled={
                          !values?.is_margin_percentage ||
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                        }
                        onKeyDown={(event) => {
                          if (event.key === "-" || event.key === "e") {
                            event.preventDefault();
                          }
                        }}
                        type="number"
                        name="margin_factor"
                        placeholder="Enter margin %"
                        label="Margin %"
                        isRequired={true}
                        labelWidth="8rem"
                      />
                    </div>
                    <div className="w-[50%] 2xl:w-[25%] lg:w-[50%] px-5 xl:px-5">
                      <div
                        className={`flex gap-5 items-center mt-3 ${
                          values?.price_list_id === "01HS5HJYWZ5DG2CW4EHX2W7A8V"
                            ? "invisible"
                            : ""
                        }`}
                      >
                        <span
                          className={`${
                            values.is_margin_percentage
                              ? "text-disabled-color"
                              : ""
                          } text-nowrap`}
                        >
                          Discount %
                        </span>
                        <button
                          type="button"
                          role="switch"
                          aria-checked={values.is_margin_percentage}
                          onClick={() => {
                            setFieldValue(
                              "is_margin_percentage",
                              !values.is_margin_percentage
                            );
                          }}
                          data-state={
                            values.is_margin_percentage
                              ? "checked"
                              : "unchecked"
                          }
                          className={`peer inline-flex h-5 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-white shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 ${
                            values.is_margin_percentage
                              ? "bg-D5E6Ff"
                              : "bg-D5E6Ff"
                          }`}
                          id="toggleSwitch"
                          aria-label="Toggle Switch"
                        >
                          <span
                            data-state={
                              values.is_margin_percentage
                                ? "checked"
                                : "unchecked"
                            }
                            className={`pointer-events-none block h-5 w-5 rounded-full bg-primary shadow-lg ring-0 transition-transform ${
                              values.is_margin_percentage
                                ? "translate-x-9"
                                : "translate-x-0"
                            }`}
                          ></span>
                        </button>
                        <span
                          className={`${
                            values.is_margin_percentage
                              ? ""
                              : "text-disabled-color"
                          } text-nowrap`}
                        >
                          Margin %
                        </span>
                      </div>
                      <div className="flex gap-12 items-center mt-12 ">
                        <CheckBox
                          conClass="flex flex-wrap justify-between gap-4 fw_600"
                          items={[
                            {
                              label: "Set as default",
                              name: "default_price_list",
                              isRequired: false,
                            },
                          ]}
                        />
                        <AddButton
                          onclkFn={handleSubmit}
                          prefixIcon={false}
                          text="Save"
                          type="submit"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <PriceListItemTable
                  setReload={setReload}
                  reload={reload}
                  paginationProps={paginationProps}
                  priceListData={priceListData}
                />
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end gap-5 px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    onclkFn={() => setSelectionCriteria(!selectionCriteria)}
                    prefixIcon={false}
                    text="Selection Criteria"
                    type="button"
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPriceList;
